export const slides = [
  {
    title: "Review from Crozdesk",
    description: "Great time tracking for team of 30+",
    signature: "Katiara",
    rating: 5,
  },
  {
    title: "Review from Software Advice",
    description: "Worth every penny! So glad my team and I use Traqq to run our small business",
    signature: "Hanna",
    rating: 5,
  },
  {
    title: "Review from Crozdesk",
    description: "Amazing support, amazing UI, data presentation is very simple and easy",
    signature: "M.Reza Ardehi",
    rating: 4.5,
  },
  {
    title: "Review from Software Advice",
    description: "Traqq has made my work experience as a freelancer much more easier and well organized",
    signature: "Amal",
    rating: 5,
  },
  {
    title: "Review from Software Advice",
    description: "It saves me time and makes it easier to be transparent with clients",
    signature: "Sara",
    rating: 5,
  },
  {
    title: "Review from Slashdot",
    description: "It’s user-friendly, ethical, and highly customizable, making it a great choice for businesses",
    signature: "Emily C.",
    rating: 5,
  },
]
